import { render, staticRenderFns } from "./ForcePasswordModal.vue?vue&type=template&id=c51f3326&scoped=true"
import script from "./ForcePasswordModal.vue?vue&type=script&lang=ts"
export * from "./ForcePasswordModal.vue?vue&type=script&lang=ts"
import style0 from "./ForcePasswordModal.vue?vue&type=style&index=0&id=c51f3326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51f3326",
  null
  
)

export default component.exports